var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilecheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M53.3333 33.3333V18.1333C53.3333 13.6528 53.3333 11.4126 52.4614 9.70133C51.6944 8.19603 50.4705 6.97219 48.9652 6.2052C47.254 5.33325 45.0137 5.33325 40.5333 5.33325H23.4667C18.9862 5.33325 16.746 5.33325 15.0347 6.2052C13.5294 6.97219 12.3056 8.19603 11.5386 9.70133C10.6667 11.4126 10.6667 13.6528 10.6667 18.1333V45.8666C10.6667 50.347 10.6667 52.5872 11.5386 54.2985C12.3056 55.8038 13.5294 57.0277 15.0347 57.7946C16.746 58.6666 18.9862 58.6666 23.4667 58.6666H32M37.3333 29.3333H21.3333M26.6667 39.9999H21.3333M42.6667 18.6666H21.3333M38.6667 50.6666L44 55.9999L56 43.9999",
    stroke: "#45C49E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilecheck);
export default __webpack_public_path__ + "static/media/filecheck.280b85cea7140aa25aafa5bba2a7ba4f.svg";
export { ForwardRef as ReactComponent };